/* @sravni/react-header version 0.2.43 */
import { __rest, __assign } from 'tslib';

/**  Helper function returns the top menu items that are hidden */
var getHiddenMenuItems = function (menu, menuState) {
    return menu.reduce(function (acc, menuItem) {
        if (!menuState[menuItem.text].inView) {
            var children = menuItem.children, rest = __rest(menuItem, ["children"]);
            acc.push(__assign(__assign({}, rest), { children: [] }));
        }
        return acc;
    }, []);
};
/** Helper function returns initial menu state */
var generateInitialMenuState = function (menu) {
    return menu.reduce(function (acc, menuItem) {
        acc[menuItem.text] = { inView: true, width: 0 };
        return acc;
    }, {});
};
/** Helper function return width of all visible menu items */
var getVisibleMenuItemsWidth = function (menuState) {
    return Object.keys(menuState).reduce(function (acc, menuText) {
        if (menuState[menuText].inView === true) {
            acc = acc + menuState[menuText].width;
        }
        return acc;
    }, 0);
};

export { generateInitialMenuState, getHiddenMenuItems, getVisibleMenuItemsWidth };
//# sourceMappingURL=navigation.js.map
